<template>
  <a-popover placement="bottomLeft" :overlayStyle="{ maxWidth: '420px' }">
    <template slot="title">
      <span class="ce-hh__title">{{ label }}</span>
    </template>
    <template slot="content">
      <p v-if="lead" class="ce-hh__lead">{{ lead }}</p>
      <dl class="ce-hh__list">
        <template v-for="item in items">
          <dt :key="item.name + '-t'" class="ce-hh__name">{{ item.name }}</dt>
          <dd :key="item.name + '-d'" class="ce-hh__meaning">{{ item.meaning }}</dd>
        </template>
      </dl>
    </template>
    <span class="ce-hh">
      {{ label }}
      <a-icon class="ce-hh__icon" type="question-circle" />
    </span>
  </a-popover>
</template>

<script>
  /**
   * A column heading that can explain itself.
   *
   * A person who opens this section for the first time meets words like
   * "Category" and "Change Type" with no way to learn what the values mean.
   * The list of possible values, and the meaning of each, belongs at the
   * heading - the one place a reader looks when a column confuses them.
   *
   * The values come from the same constants the cells use, so a heading can
   * never describe a value the table no longer shows.
   */
  export default {
    name: 'HeaderHelp',
    props: {
      /** The column heading itself. */
      label: {
        type: String,
        required: true
      },
      /** One sentence above the list. Optional. */
      lead: {
        type: String,
        default: ''
      },
      /** `[{ name, meaning }]` — every value this column can hold. */
      items: {
        type: Array,
        required: true
      }
    }
  };
</script>

<style lang="scss" scoped>
  .ce-hh {
    cursor: help;
    white-space: nowrap;

    &__icon {
      margin-left: 4px;
      font-size: 11px;
      color: #8c8c8c;
    }
    &:hover &__icon {
      color: #20a4b8;
    }
    &__title {
      font-weight: 600;
    }
    &__lead {
      margin: 0 0 8px;
      color: #595959;
      white-space: normal;
    }
    &__list {
      margin: 0;
    }
    &__name {
      font-weight: 600;
      color: #262626;
      margin-top: 6px;
      white-space: normal;

      &:first-child {
        margin-top: 0;
      }
    }
    &__meaning {
      margin: 0 0 0 0;
      color: #595959;
      white-space: normal;
    }
  }
</style>
